import {
  Box,
  List,
  ListItem,
  ListItemText,
  Typography,
  useTheme,
} from '@mui/material'
import { Dispatch, DragEvent, SetStateAction, useRef } from 'react'
import { BrowseFileButton, DNDContainer } from './drag-and-drop-field.styles'

interface DragAndDropFieldProps {
  files: FileList | null
  setFiles: Dispatch<SetStateAction<FileList | null>>
  multiple?: boolean
}

const DragAndDropField = ({
  files,
  setFiles,
  multiple = false,
}: DragAndDropFieldProps) => {
  const theme = useTheme()
  const inputRef = useRef<HTMLInputElement>(null)

  const handleDragOver = (event: DragEvent<HTMLDivElement>) => {
    event.preventDefault()
    console.log('handleDragOver')
  }

  const handleDrop = (event: DragEvent<HTMLDivElement>) => {
    event.preventDefault()
    setFiles(event.dataTransfer.files)
  }

  const handleClick = () => {
    inputRef?.current?.click()
  }

  if (!!files) {
    return (
      <DNDContainer theme={theme}>
        <List>
          <ListItem>
            <ListItemText>
              {Array.from(files).map((file) => file.name)}
            </ListItemText>
          </ListItem>
        </List>
      </DNDContainer>
    )
  }

  return (
    <>
      {!files && (
        <DNDContainer
          theme={theme}
          onDragOver={handleDragOver}
          onDrop={handleDrop}
        >
          <Box my={2}>
            <Typography variant="body2">Drag & Drop</Typography>
            <Typography variant="body2">or</Typography>
          </Box>
          <Box mb={2}>
            <input
              type="file"
              multiple={multiple}
              hidden
              ref={inputRef}
              onChange={(event) => setFiles(event.target.files)}
            />
            <BrowseFileButton
              variant="contained"
              size="small"
              onClick={handleClick}
            >
              Browse File
            </BrowseFileButton>
          </Box>
        </DNDContainer>
      )}
    </>
  )
}

export default DragAndDropField
